import { render, staticRenderFns } from "./P02.vue?vue&type=template&id=1fb4f6bf&scoped=true"
import script from "./P02.vue?vue&type=script&lang=js"
export * from "./P02.vue?vue&type=script&lang=js"
import style0 from "./P02.vue?vue&type=style&index=0&id=1fb4f6bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb4f6bf",
  null
  
)

export default component.exports